import React from 'react';
import Loader from '../Parts/Loader';

const Loading = () => {
  return (
    <Loader type="color" size="large" />
  );
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.jsx